import { useNavigate } from "react-router-dom";
import SystemErrorPanel from "@/components/ui/error-6";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="w-full max-w-4xl">
        <SystemErrorPanel onButtonClick={() => navigate("/")} />
      </div>
    </div>
  );
};

export default NotFound;
